import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const LoginRedirectGuard = ({ children }) => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const decodedUser = useSelector((state) => state.auth.decodedUser);
  const role = Number(
    decodedUser?.[
      "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
    ]
  );
  if (isAuthenticated) {
    if (role === 5) {
      window.location.href = "https://pendartarharia.com";

      return null;
    }
    return <Navigate to="/employer" />;
  }

  return children;
};

export default LoginRedirectGuard;
